import { useEffect, useState } from "react"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"
import "./css/Quotes.css"
import { SpinnerCircular } from "spinners-react"
import CreateExpense from "./CreateExpense"
import ExpensesStarter from "../components/ExpensesStarter"
import ExpensesList from "../components/ExpensesList"

const Expenses = () => {
    const [createExpense, setCreateExpense] = useState(false)
    const [expensesList, setExpensesList] = useState([])
    const [loading, setLoading] = useState(true)

    const token = localStorage.getItem("_crm__token")

    const fetchExpenses = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/expenses-list`, { token })

        setLoading(false)
        
        if (data.success) {
            setExpensesList(data.expenses)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchExpenses()
    }, [])
    useEffect(() => {
        fetchExpenses()
    }, [createExpense])

    if (createExpense) {
        return <CreateExpense setCreateExpense={setCreateExpense} />
    }

    if (loading) {
        return (
            <div className="_5dut">
                <SpinnerCircular size="60" color="#3b70ad" />
            </div>
        )
    }

    if (expensesList.length) {
        return (
            <ExpensesList expensesList={expensesList} setExpensesList={setExpensesList} setCreateExpense={setCreateExpense} />
        )
    }

    // New user - no quotes created
    return (
        <ExpensesStarter setCreateExpense={setCreateExpense} />
    )
}

export default Expenses

